import { MASCOT_EYES } from "@/components/brand/Mascot";

const S = { fill: "none", stroke: "currentColor", strokeWidth: 3.5, strokeLinecap: "round", strokeLinejoin: "round" };
const VB = { crown: "-6 -36 112 148", tongue: "-6 -6 112 120", peace: "-36 -6 172 118", headphones: "-20 -24 140 136" };

const Eye = ({ cx, bg }) => (
  <g>
    <ellipse cx={cx} cy="63" rx="17" ry="11.5" fill={bg} />
    <path d={`M${cx - 16.6} 60.7H${cx + 16.6}`} strokeWidth="4" />
    <circle cx={cx + 7} cy="66.5" r="4.8" fill="currentColor" stroke="none" />
  </g>
);

const SleepyEye = ({ cx, bg }) => (
  <g><ellipse cx={cx} cy="63" rx="17" ry="11.5" fill={bg} /><path d={`M${cx - 16.9} 65H${cx + 16.9}`} strokeWidth="4" /><path d={`M${cx - 5} 70a5 4 0 0 0 10 0`} fill="currentColor" stroke="none" /></g>
);

const Hand = ({ bg }) => (
  <g fill={bg}>
    <rect x="-27" y="34" width="9" height="34" rx="4.5" transform="rotate(-14 -22 66)" />
    <rect x="-15" y="31" width="9" height="36" rx="4.5" transform="rotate(6 -10 66)" />
    <rect x="-29" y="60" width="28" height="26" rx="10" />
    <path d="M-22 70h13" />
  </g>
);

export const MascotDoodle = ({ variant = "crown", size = 160, bg = "#F4F3EC", className = "", label }) => {
  const sleepy = variant === "headphones";
  const wink = variant === "peace";
  return (
    <svg viewBox={VB[variant]} width={size} className={`h-auto ${className}`} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <g {...S}>
        {variant === "headphones" && <><path d="M-4 50C-6-20 106-20 104 50" strokeWidth="5" /><rect x="-16" y="38" width="20" height="38" rx="8" fill={bg} /><rect x="96" y="38" width="20" height="38" rx="8" fill={bg} /></>}
        {variant === "peace" && <><Hand bg={bg} /><g transform="translate(100 0) scale(-1 1)"><Hand bg={bg} /></g></>}
        <rect x="3" y="3" width="94" height="100" rx="21" fill={bg} strokeWidth="5" />
        {variant === "crown" && <path d="M22 1L24-25l14 13 12-20 12 20 14-13 2 26z" fill={bg} transform="rotate(-5 50 -10)" />}
        <path d="M20 42L39 43M57 39L82 28" strokeWidth="6" />
        {sleepy ? MASCOT_EYES.map((cx) => <SleepyEye key={cx} cx={cx} bg={bg} />) : (
          <>
            <Eye cx={31} bg={bg} />
            {wink ? <path d="M53 64q16-11 32 0" strokeWidth="4" /> : <Eye cx={69} bg={bg} />}
          </>
        )}
        {variant === "tongue" && <><path d="M38 86q13 5 26-1" /><path d="M48 88q-1 11 7 11t7-12" fill={bg} /><path d="M55 90v5" strokeWidth="2" /></>}
        {sleepy && <path d="M104-8h10l-10 10h10M118-20h6l-6 6h6" strokeWidth="2.5" />}
      </g>
    </svg>
  );
};
